<template>
  <div>
    <div class="comm_popup_wrap_large">
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TXT_SQL_DEFAULT_INFO') }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TAB')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              ref="sqlTableName"
              v-model="frame0.sqlTableName"
              maxlength="30"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_COL')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              ref="sqlColumnName"
              v-model="frame0.sqlColumnName"
              maxlength="30"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_FORMAT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="sqlColumnType"
              :selected="frame0.selectedCode.COD_SQL_TYPE"
              codeId="COD_SQL_COL_TYPE"
              :initialSelectedIndex="0"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_DEFAULT_VAL')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              ref="sqlBasicValue"
              v-model="frame0.sqlBasicValue"
              maxlength="30"
            />
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TXT_COND_PRG_EDIT') }}</h4>
      </div>
      <div class="module_msg_box width100">
        <textarea
          ref="sqlConditionContent"
          v-model="frame0.sqlConditionContent"
          name="name"
          rows="5"
          maxlength="250"
          @blur="setBindingParam"
        />
        <!-- <div class="msg_btn_group mrT05">
          <sui-button
            type="button"
            name="button"
            class="comm_sbtn_border"
          >
            {{ $t('MSG_BTN_VALID_CHK') }}
          </sui-button>
        </div> -->
      </div>
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TXT_PRMT_SET') }}</h4>
      </div>
      <sui-grid
        ref="grid"
        :columns="gridColumns0"
        :dataset="'dsConditionBind'"
        :showDisplayCountControl="false"
      />
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onClickCancel"
      >
        {{ $t('MSG_BTN_CANCEL') }}
      </sui-button>
      <sui-button
        type="button"
        class="comm_btn_solid"
        @click="onClickApply"
      >
        {{ $t('MSG_BTN_APPLY') }}
      </sui-button>
    </div>

    <sui-popup
      v-model="isPopupShow"
      :title="$t('MSG_TIT_PRMT_MGT')"
    >
      <p02
        :pageId="pageId"
        :ruleUid="ruleUid"
        :ruleName="ruleName"
        @popupClose="popupClose"
        @paramReturn="paramReturn"
      />
    </sui-popup>
  </div>
</template>
<script>
import p02 from './PGE_CMR_00008_P02';
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMR_00001_P03', // eslint-disable-line vue/name-property-casing
  components: {
    p02,
  },
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: null,
    },
    ruleUid: {
      type: String,
      default: null,
    },
    ruleConditionInfo: {
      type: Object,
      default: null,
    },
    ruleName: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isPopupShow: false,
      frame0: {
        selectedCode: {
          COD_SQL_TYPE: { key: '', label: '' },
        },
        sqlTableName: '',
        sqlColumnName: '',
        sqlBasicValue: '',
        sqlConditionContent: '',
      },
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_ORDER'),
        datafield: 'arrayalOrder',
        width: '60',
      }, {
        text: this.$t('MSG_TXT_BND_VAL'),
        datafield: 'ruleConditionBindValue',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellTextFieldWithButton(row, column, value, htmlElement, {
            textFieldProps: {
              readonly: false,
              disabled: false,
            },
            buttonProps: {
              disabled: false,
              style: 'comm_btn_InputScr',
            },
            handler: this.onClickButton,
          }, this.dsConditionBind, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }],
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dsConditionBind',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'ruleConditionBindUid', map: 'ruleConditionBindUid' },
      { type: 'string', name: 'ruleConditionUid', map: 'ruleConditionUid' },
      { type: 'string', name: 'ruleConditionBindValue', map: 'ruleConditionBindValue' },
      { type: 'string', name: 'arrayalOrder', map: 'arrayalOrder' }],
  }],
  mounted() {
    this.$nextTick(() => {
      // 기본정보 셋팅
      this.setRuleConditionMasterData();
      // 바인딩 정보 셋팅
      if (!utils.isEmpty(this.ruleConditionInfo.ruleConditionBindInfo.saveRuleConditionBindList)
      && !utils.isUndefined(this.ruleConditionInfo.ruleConditionBindInfo.saveRuleConditionBindList)) {
        const conditionBindList = this.ruleConditionInfo.ruleConditionBindInfo.saveRuleConditionBindList;
        this.dsConditionBind.submit();
        this.dsConditionBind.setRawData(conditionBindList); // 데이터 셋에 데이터를 넣는 함수
      } else if (!utils.isEmpty(this.ruleConditionInfo.ruleConditionUid)) {
        this.setBindingParamInit();
      }
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /**
     * sql 기본정보 SET
     */
    setRuleConditionMasterData() {
      utils.forEach(this.frame0, (value, key) => {
        if (utils.isEqual(key, 'selectedCode')) {
          this.frame0[key].COD_SQL_TYPE.key = this.ruleConditionInfo.sqlColumnTypeCode;
        } else {
          this.frame0[key] = this.ruleConditionInfo[key];
        }
      });
    },
    /**
     * 파라미터 바인딩 최초 값 조회
     */
    setBindingParamInit() {
      http.request(this.pageId, 'DTS_CMR_00045', {
        path: {
          'rule-condition-uid': this.ruleConditionInfo.ruleConditionUid,
        },
      }).then(res => {
        this.dsConditionBind.submit();
        this.dsConditionBind.setRawData(res.data); // 데이터 셋에 데이터를 넣는 함수
      });
    },
    /**
     * 파라미터 바인딩 grid
     * 조건 절 '?' 개수만큼 grid row 생성
     */
    setBindingParam() {
      const { sqlConditionContent } = this.frame0;
      const result = sqlConditionContent.match(/\?/g);
      const rowList = [];

      if (!utils.isEmpty(result)) {
        utils.forEach(result, (value, key) => {
          const defaultRow = {
            arrayalOrder: key + 1,
            ruleConditionBindValue: '',
          };
          rowList.push(defaultRow);
        });
      }
      this.dsConditionBind.setRawData(rowList);
    },
    /**
     * 파라미터 관리 팝업
     */
    onClickButton(event, dataRow) {
      this.rowId = dataRow['dataset-row-id'];
      this.isPopupShow = true;
    },
    popupClose() {
      this.isPopupShow = false;
    },
    paramReturn(paramValue) {
      const index = utils.findIndex(this.dsConditionBind.data, o => utils.isEqual(o['dataset-row-id'], this.rowId));
      const value = this.dsConditionBind.data[index].ruleConditionBindValue + paramValue;
      this.dsConditionBind.setData(index, 'ruleConditionBindValue', value);
    },
    /**
     * BUTTON EVENT
     */
    onClickApply() {
      const info = this.frame0;
      const ruleComparisonValue = `SELECT ${info.sqlColumnName}FROM ${info.sqlTableName}`;
      const sqlInfo = {
        sqlTableName: info.sqlTableName,
        sqlColumnName: info.sqlColumnName,
        sqlBasicValue: info.sqlBasicValue,
        sqlConditionContent: info.sqlConditionContent,
        sqlColumnTypeCode: info.selectedCode.COD_SQL_TYPE.key,
        ruleComparisonValueTypeCode: 'SQ',
        ruleComparisonValue,
      };

      if (!this.validationCheck()) return false;

      this.$emit('paramReturn', sqlInfo, utils.clone(this.dsConditionBind.data));
      this.$emit('popupClose');

      return null;
    },
    onClickCancel() {
      this.$emit('popupClose');
    },
    /**
     * 입력 유효성 체크
     */
    validationCheck() {
      let flag = true;

      if (utils.isEmpty(utils.trim(this.frame0.sqlTableName))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_TAB')),
          null,
          () => {
            this.$refs.sqlTableName.setFocus();
          });
        return false;
      }
      if (utils.isEmpty(utils.trim(this.frame0.sqlColumnName))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_COL')),
          null,
          () => {
            this.$refs.sqlColumnName.setFocus();
          });
        return false;
      }
      if (utils.isEmpty(utils.trim(this.frame0.selectedCode.COD_SQL_TYPE.key))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_FORMAT')));
        return false;
      }
      if (utils.isEmpty(utils.trim(this.frame0.sqlBasicValue))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_DEFAULT_VAL')),
          null,
          () => {
            this.$refs.sqlBasicValue.setFocus();
          });
        return false;
      }
      utils.forEach(this.dsConditionBind.data, (obj, row) => {
        if (utils.isEmpty(obj.ruleConditionBindValue)) {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'),
            row + 1,
            this.$t('MSG_TXT_BND_VAL')),
          null,
          () => {
            this.gridSetFocus(row, 'ruleConditionBindValue');
          });
          flag = false;
          return false;
        }
        return null;
      });
      return flag;
    },
    gridSetFocus(rowIndex, datafield) {
      this.$refs.grid.$refs.grid.ensurerowvisible(rowIndex);

      const editor = this.$refs.grid.getCellEditor(rowIndex, datafield);

      if (editor) {
        editor.getComponentInstance().setFocus();
      }
    },
  },
};
</script>
<style scoped>
</style>
